export enum TravelType {
  OneWay = 'oneway',
  RoundTrip = 'roundtrip',
}

export const isOneWayTrip = (travelType: TravelType): travelType is TravelType.OneWay =>
  travelType === TravelType.OneWay;
export const isRoundTrip = (travelType: TravelType): travelType is TravelType.OneWay =>
  travelType === TravelType.RoundTrip;
